import { partial } from "filesize";

/**
 * Formats file size using base 2 (binary) calculation with JEDEC standard.
 * JEDEC standard uses KB, MB, GB instead of KiB, MiB, GiB.
 *
 * Examples:
 * formatFileSize(1024) => "1 KB"
 * formatFileSize(1048576) => "1 MB"
 * formatFileSize(1073741824) => "1 GB"
 */
export const formatFileSize = partial({
  base: 2,
  standard: "jedec",
});
